import Vue from "vue";

Vue.component("dark-mode-toggle", {
    data() {
        return {
            // Initialisiere mit dem aktuellen Theme (falls bereits gesetzt)
            isDarkMode: (typeof localStorage !== 'undefined' && localStorage.getItem('theme') === 'light') ? false : true
        };
    },

    mounted() {
        // SSR-safe: Only run on client
        if (typeof localStorage === "undefined" || typeof document === "undefined") {
            return;
        }
        
        // Load saved theme preference from localStorage
        const savedTheme = localStorage.getItem("theme");
        
        if (savedTheme === "dark") {
            this.isDarkMode = true;
            document.documentElement.setAttribute("data-theme", "dark");
        } else if (savedTheme === "light") {
            this.isDarkMode = false;
            document.documentElement.setAttribute("data-theme", "light");
        } else {
            // Default to dark mode
            this.isDarkMode = true;
            document.documentElement.setAttribute("data-theme", "dark");
            localStorage.setItem("theme", "dark");
        }
        
        // Try to load theme from server (for logged-in users)
        // This happens async and updates if needed
        this.loadThemeFromServer();

        // Listen for system theme changes
        if (typeof window !== "undefined" && window.matchMedia) {
            window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
                if (!localStorage.getItem("theme")) {
                    this.isDarkMode = e.matches;
                    document.documentElement.setAttribute("data-theme", e.matches ? "dark" : "light");
                }
            });
        }
    },

    methods: {
        async loadThemeFromServer() {
            // SSR-safe: Only run on client
            if (typeof localStorage === "undefined" || typeof document === "undefined") {
                return;
            }
            
            try {
                const response = await fetch('/rest/fanliebling/theme/get');
                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.theme) {
                        const serverTheme = data.theme;
                        const localTheme = localStorage.getItem("theme");
                        
                        // Nur updaten wenn Server-Theme sich vom lokalen unterscheidet
                        if (serverTheme !== localTheme) {
                            this.isDarkMode = serverTheme === "dark";
                            document.documentElement.setAttribute("data-theme", serverTheme);
                            localStorage.setItem("theme", serverTheme);
                        }
                    }
                }
            } catch (error) {
                console.error('[ThemeController] Error loading theme from server:', error);
                // Continue with localStorage fallback
            }
        },
        
        async saveThemeToServer(theme) {
            try {
                const response = await fetch('/rest/fanliebling/theme/save?theme=' + theme, {
                    method: 'POST'
                });
                
                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {                        
                    }
                }
            } catch (error) {
                console.error('[ThemeController] Error saving theme to server:', error);
                // Theme is still saved to localStorage, so no user-facing error
            }
        },
        
        toggleTheme() {
            // SSR-safe: Only run on client
            if (typeof localStorage === "undefined" || typeof document === "undefined") {
                return;
            }
            
            this.isDarkMode = !this.isDarkMode;
            const theme = this.isDarkMode ? "dark" : "light";
            
            // Save preference to localStorage (instant)
            localStorage.setItem("theme", theme);
            
            // Apply theme to document (instant)
            document.documentElement.setAttribute("data-theme", theme);
            
            // Save to server (async, doesn't block UI)
            this.saveThemeToServer(theme);
        }
    },

    render: function(createElement) {
        return createElement(
            "div",
            {
                class: {
                    "dark-mode-toggle-switch": true,
                    "light": !this.isDarkMode
                },
                attrs: {
                    "aria-label": this.isDarkMode ? "Hellen Modus aktivieren" : "Dunklen Modus aktivieren",
                    "title": this.isDarkMode ? "Hellen Modus aktivieren" : "Dunklen Modus aktivieren",
                    "role": "button",
                    "tabindex": "0"
                },
                on: {
                    click: this.toggleTheme
                }
            },
            [
                createElement(
                    "div",
                    { class: "toggle-track" },
                    [
                        createElement("i", { class: "fa fa-sun-o toggle-icon icon-dark" }),
                        createElement("i", { class: "fa fa-moon-o toggle-icon icon-light" })
                    ]
                ),
                createElement("div", { class: "toggle-thumb" })
            ]
        );
    }
});
